(() => {
  if (window.DeebAccessoryEditionLabel) return;

  const ROOT_SELECTOR = 'product-info[data-product-family="accessory"]';
  const EDITION_SELECTOR = '[data-deeb-accessory-edition]';
  const LABEL_SELECTOR = '[data-deeb-accessory-edition-label]';

  const normalizeLabel = (value) => value.replace(/\s+/g, ' ').trim();

  const getRoot = (sectionId) => {
    if (!sectionId) return null;

    return [...document.querySelectorAll(ROOT_SELECTOR)].find(
      (root) => root.dataset.section === String(sectionId)
    );
  };

  const hideEdition = (root) => {
    const destination = root?.querySelector(EDITION_SELECTOR);
    const label = destination?.querySelector(LABEL_SELECTOR);

    if (!destination || !label) return;

    label.textContent = '';
    destination.hidden = true;
  };

  const syncEdition = ({ sectionId, html } = {}) => {
    const root = getRoot(sectionId);
    if (!root) return;

    const destination = root.querySelector(EDITION_SELECTOR);
    const destinationLabel = destination?.querySelector(LABEL_SELECTOR);
    const source = html?.getElementById?.(`DeebAccessoryEdition-${sectionId}`);
    const sourceLabel = source?.querySelector(LABEL_SELECTOR);

    if (!destination || !destinationLabel) return;

    const label = normalizeLabel(sourceLabel?.textContent || '');
    destinationLabel.textContent = label;
    destination.hidden = label === '';
  };

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    if (PUB_SUB_EVENTS.optionValueSelectionChange) {
      subscribe(PUB_SUB_EVENTS.optionValueSelectionChange, ({ data } = {}) => {
        const target = data?.event?.target;
        const root = target?.closest?.(ROOT_SELECTOR);
        if (root) hideEdition(root);
      });
    }

    if (PUB_SUB_EVENTS.variantChange) {
      subscribe(PUB_SUB_EVENTS.variantChange, ({ data } = {}) => {
        syncEdition(data);
      });
    }
  }

  window.DeebAccessoryEditionLabel = Object.freeze({
    sync: syncEdition,
  });
})();
